import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.authoring');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-authoring',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.authoring/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.console-shell {
  --sidebar-width: 196px;
  min-height: 100vh;
  color: var(--kiom-ink);
  background: #f5f7f6;
}

.service-timezone {
  margin-left: auto;
  padding: 5px 8px;
  border: 1px solid #dbe4e0;
  border-radius: 7px;
  color: #5f7069;
  background: #fff;
  font-size: 10px;
  font-weight: 700;
}

.console-shell.sidebar-collapsed {
  --sidebar-width: 58px;
}

.console-sidebar {
  position: fixed;
  z-index: 40;
  inset: 0 auto 0 0;
  box-sizing: border-box;
  width: var(--sidebar-width);
  display: flex;
  overflow: visible;
  flex-direction: column;
  border-right: 1px solid #e1e6e3;
  background: #f7f8f7;
  transition: width 0.18s ease, transform 0.2s ease;
}

.sidebar-header {
  min-height: 64px;
  display: grid;
  align-items: center;
  padding: 0 10px;
  border-bottom: 1px solid #e5e9e7;
  grid-template-columns: minmax(0, 1fr);
  gap: 6px;
}

.console-brand {
  min-width: 0;
  display: flex;
  align-items: center;
  color: #213a33;
  text-decoration: none;
  gap: 9px;
}

.brand-symbol {
  position: relative;
  width: 36px;
  height: 23px;
  display: block;
  overflow: hidden;
  flex: 0 0 auto;
  background: transparent;
}

.brand-symbol img {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 94px;
  max-width: none;
  height: auto;
}

.brand-copy {
  min-width: 0;
}

.brand-copy strong,
.brand-copy small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.brand-copy strong {
  color: #213a33;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.brand-copy small {
  margin-top: 2px;
  color: #87938f;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.sidebar-collapse,
.sidebar-close {
  width: 28px;
  height: 28px;
  display: grid;
  padding: 0;
  border: 0;
  border-radius: 6px;
  place-items: center;
  color: #74827d;
  background: transparent;
}

.sidebar-collapse {
  position: absolute;
  z-index: 3;
  top: 50%;
  right: -12px;
  width: 24px;
  height: 40px;
  border: 1px solid #dbe3df;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 3px 10px rgba(32, 58, 49, 0.12);
  transform: translateY(-50%);
}

.sidebar-collapse:hover,
.sidebar-close:hover {
  color: #244a3e;
  background: #ecefed;
}

.sidebar-collapse svg,
.sidebar-close svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.sidebar-close {
  display: none;
}

.console-nav {
  min-height: 0;
  flex: 1;
  overflow-y: auto;
  padding: 12px 8px 16px;
  scrollbar-color: #cbd3d0 transparent;
  scrollbar-width: thin;
}

.nav-group + .nav-group {
  margin-top: 16px;
}

.dataset-work-group {
  margin-top: 0;
}

.nav-group p {
  margin: 0 10px 6px;
  color: #8a9692;
  font-size: 10px;
  font-weight: 650;
}

.console-nav a {
  position: relative;
  min-height: 36px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  border-radius: 6px;
  color: #596a64;
  text-decoration: none;
  transition: color 0.12s ease, background 0.12s ease;
  gap: 9px;
}

.console-nav a:hover {
  color: #273f37;
  background: #ecefed;
}

.console-nav a.is-active {
  color: #145d48;
  background: #e5ece9;
  font-weight: 700;
}

.console-nav a.is-active::before {
  position: absolute;
  top: 8px;
  bottom: 8px;
  left: 0;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: #24775c;
  content: "";
}

.console-nav a:focus-visible,
.console-brand:focus-visible,
.sidebar-collapse:focus-visible,
.sidebar-close:focus-visible,
.sidebar-user-actions > a:focus-visible,
.sidebar-user-actions > button:focus-visible {
  outline: 2px solid #438b75;
  outline-offset: 1px;
}

.nav-icon {
  width: 19px;
  height: 19px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  color: #788680;
}

.console-nav a.is-active .nav-icon {
  color: #176f54;
}

.nav-icon svg {
  width: 17px;
  height: 17px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.7;
}

.console-nav a > span:last-child {
  overflow: hidden;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sidebar-foot {
  display: grid;
  align-items: center;
  padding: 10px;
  border-top: 1px solid #e1e6e3;
  background: #f7f8f7;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 8px;
}

.user-avatar {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #175d49;
  background: #dfeae6;
  font-size: 10px;
  font-weight: 800;
}

.sidebar-user-copy,
.sidebar-user-copy strong,
.sidebar-user-copy small {
  display: block;
  min-width: 0;
}

.sidebar-user-copy strong,
.sidebar-user-copy small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sidebar-user-copy strong {
  color: #30443d;
  font-size: 10px;
}

.sidebar-user-copy small {
  margin-top: 2px;
  color: #87938f;
  font-size: 8px;
}

.sidebar-user-actions {
  display: flex;
  align-items: center;
  gap: 1px;
}

.sidebar-user-actions > a,
.sidebar-user-actions > button {
  width: 26px;
  height: 26px;
  display: grid;
  padding: 0;
  border: 0;
  border-radius: 6px;
  place-items: center;
  color: #71817b;
  background: transparent;
}

.sidebar-user-actions > a:hover,
.sidebar-user-actions > button:hover {
  color: #145d48;
  background: #e9eeeb;
}

.sidebar-user-actions svg {
  width: 15px;
  height: 15px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.console-body {
  min-height: 100vh;
  padding-left: var(--sidebar-width);
  transition: padding-left 0.18s ease;
}

.console-topbar {
  position: sticky;
  z-index: 20;
  top: 0;
  box-sizing: border-box;
  height: 56px;
  display: none;
  align-items: center;
  padding: 0 16px;
  border-bottom: 1px solid #e1e6e3;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(10px);
}

.mobile-section-title {
  color: #2d433c;
  font-size: 13px;
  font-weight: 700;
}

.console-main {
  min-height: 100vh;
}

.menu-button {
  width: 34px;
  height: 34px;
  display: none;
  margin-right: 12px;
  padding: 7px;
  border: 1px solid #dbe4e0;
  border-radius: 7px;
  background: #fff;
}

.menu-button span {
  width: 18px;
  height: 1.5px;
  display: block;
  margin: 4px 0;
  background: #38534b;
}

.mobile-scrim {
  position: fixed;
  z-index: 30;
  inset: 0;
  background: rgba(10, 28, 24, 0.42);
}

.app-loading {
  position: fixed;
  z-index: 100;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(15, 32, 31, 0.2);
  backdrop-filter: blur(4px);
}

.loading-spinner {
  width: 44px;
  height: 44px;
  color: var(--kiom-primary);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

@media (min-width: 921px) {
  .console-sidebar.is-collapsed .sidebar-header {
    justify-content: center;
    padding: 0 11px;
    grid-template-columns: 36px;
    gap: 0;
  }
  .console-sidebar.is-collapsed .brand-copy,
  .console-sidebar.is-collapsed .nav-group p,
  .console-sidebar.is-collapsed .console-nav a > span:last-child,
  .console-sidebar.is-collapsed .sidebar-user-copy {
    display: none;
  }
  .console-sidebar.is-collapsed .console-brand {
    justify-content: center;
  }
  .console-sidebar.is-collapsed .sidebar-collapse svg {
    transform: rotate(180deg);
  }
  .console-sidebar.is-collapsed .console-nav {
    padding: 12px 8px 16px;
  }
  .console-sidebar.is-collapsed .nav-group + .nav-group {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #e1e6e3;
  }
  .console-sidebar.is-collapsed .console-nav a {
    min-height: 38px;
    justify-content: center;
    padding: 0;
  }
  .console-sidebar.is-collapsed .console-nav a.is-active::before {
    top: 9px;
    bottom: 9px;
  }
  .console-sidebar.is-collapsed .sidebar-foot {
    display: flex;
    flex-direction: column;
    padding: 9px 0;
    gap: 6px;
  }
  .console-sidebar.is-collapsed .sidebar-user-actions {
    flex-direction: column;
  }
}
@media (max-width: 920px) {
  .console-sidebar,
  .console-sidebar.is-collapsed {
    width: min(244px, 100vw - 28px);
    box-shadow: 16px 0 40px rgba(12, 38, 31, 0.14);
    transform: translateX(-105%);
  }
  .console-sidebar.is-open {
    transform: translateX(0);
  }
  .sidebar-collapse {
    display: none;
  }
  .sidebar-header {
    grid-template-columns: minmax(0, 1fr) 28px;
  }
  .sidebar-close {
    display: grid;
  }
  .console-body {
    padding-left: 0;
  }
  .menu-button {
    display: block;
  }
  .console-topbar {
    display: flex;
  }
  .console-main {
    min-height: calc(100vh - 56px);
  }
}`],
})
export class LayoutAuthoringComponent implements OnInit {
    public menuOpen: boolean = false;
    public sidebarCollapsed: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.check()) {
            location.href = '/access';
            return;
        }
        let session = this.service.auth.session || {};
        if (session.account_status !== 'ACTIVE') {
            location.href = '/status/pending';
            return;
        }
        if ((session.portals || []).indexOf('authoring') < 0 && session.user_type !== 'SYSTEM_ADMIN') {
            location.href = '/forbidden';
        }
        if (typeof window !== 'undefined') {
            this.sidebarCollapsed = window.localStorage.getItem('authoring-sidebar-collapsed') === '1';
        }
    }

    public async toggleMenu() {
        this.menuOpen = !this.menuOpen;
        await this.service.render();
    }

    public async closeMenu() {
        this.menuOpen = false;
        await this.service.render();
    }

    public async toggleSidebar() {
        this.sidebarCollapsed = !this.sidebarCollapsed;
        if (typeof window !== 'undefined') {
            window.localStorage.setItem(
                'authoring-sidebar-collapsed',
                this.sidebarCollapsed ? '1' : '0'
            );
        }
        await this.service.render();
    }

    public isActive(path: string) {
        return location.pathname.indexOf(path) === 0;
    }

    public isDashboard() {
        return location.pathname === '/authoring' || location.pathname === '/authoring/';
    }

    public brandLink() {
        return '/authoring';
    }

    public isSourceSection() {
        return this.isActive('/authoring/sources')
            || this.isActive('/authoring/text-units');
    }

    public isQualitySection() {
        return this.isActive('/authoring/quality');
    }

    public isQaGenerationSection() {
        return this.isActive('/authoring/datasets')
            || this.isActive('/authoring/runs')
            || this.isActive('/authoring/candidates');
    }

    public isReviewSection() {
        return this.isActive('/authoring/review-batches')
            || this.isActive('/authoring/adjudications');
    }

    public isAdmin() {
        return this.service.auth.session.user_type === 'SYSTEM_ADMIN';
    }

    private availableRoles() {
        let entries = this.service.auth.session.dataset_roles || [];
        let roles: string[] = [];
        entries.forEach((dataset: any) => {
            (dataset.roles || []).forEach((role: string) => {
                if (roles.indexOf(role) < 0) roles.push(role);
            });
        });
        return roles;
    }

    public canUseQaGeneration() {
        if (this.isAdmin()) return true;
        let roles = this.availableRoles();
        return roles.indexOf('AUTHOR') >= 0
            || roles.indexOf('DATASET_ADMIN') >= 0
            || roles.indexOf('GENERATION_OPERATOR') >= 0
            || roles.indexOf('REVIEW_ADMIN') >= 0
            || roles.indexOf('RELEASE_ADMIN') >= 0;
    }

    public canUseSources() {
        if (this.isAdmin()) return true;
        let roles = this.availableRoles();
        return roles.indexOf('AUTHOR') >= 0
            || roles.indexOf('DATASET_ADMIN') >= 0
            || roles.indexOf('GENERATION_OPERATOR') >= 0
            || roles.indexOf('REVIEW_ADMIN') >= 0
            || roles.indexOf('RELEASE_ADMIN') >= 0;
    }

    public canUseQuality() {
        if (this.isAdmin()) return true;
        let roles = this.availableRoles();
        return roles.indexOf('AUTHOR') >= 0
            || roles.indexOf('DATASET_ADMIN') >= 0
            || roles.indexOf('GENERATION_OPERATOR') >= 0
            || roles.indexOf('REVIEW_ADMIN') >= 0
            || roles.indexOf('ADJUDICATOR') >= 0
            || roles.indexOf('RELEASE_ADMIN') >= 0;
    }

    public qaGenerationLink() {
        return '/authoring/runs';
    }

    public canPublishReview() {
        if (this.isAdmin()) return true;
        let roles = this.availableRoles();
        return roles.indexOf('DATASET_ADMIN') >= 0
            || roles.indexOf('REVIEW_ADMIN') >= 0;
    }

    public canManageReviews() {
        return this.canPublishReview() || this.canAdjudicate();
    }

    public reviewManagementLink() {
        return this.canPublishReview()
            ? '/authoring/review-batches'
            : '/authoring/adjudications';
    }

    public canAdjudicate() {
        let roles = this.availableRoles();
        return this.isAdmin()
            || roles.indexOf('REVIEW_ADMIN') >= 0
            || roles.indexOf('ADJUDICATOR') >= 0;
    }

    public canRelease() {
        let roles = this.availableRoles();
        return this.isAdmin() || roles.indexOf('RELEASE_ADMIN') >= 0;
    }

    public userInitial() {
        let name = this.service.auth.session.name || '사용자';
        return name.substring(0, 1);
    }

    public roleLabel() {
        if (this.isAdmin()) return '시스템 관리자';
        let roles = this.availableRoles();
        let labels: any = {
            DATASET_ADMIN: '데이터셋 관리자',
            AUTHOR: 'QA 저작자',
            GENERATION_OPERATOR: '생성 운영자',
            REVIEW_ADMIN: '검수 관리자',
            ADJUDICATOR: '이견 조정자',
            RELEASE_ADMIN: '릴리스 관리자'
        };
        let matched = Object.keys(labels).filter((role: string) => roles.indexOf(role) >= 0);
        return matched.length > 1 ? '복수 역할' : (matched.length ? labels[matched[0]] : '데이터 운영자');
    }

    public currentSection() {
        if (this.isActive('/admin/accounts')) return '계정 관리';
        if (this.isQualitySection()) return '저작 품질 센터';
        if (this.isActive('/authoring/releases')) return '결과 데이터셋';
        if (this.isReviewSection()) return '검수 관리';
        if (this.isQaGenerationSection()) return 'QA 생성';
        if (this.isSourceSection()) return '원천 데이터';
        return '진행 현황';
    }

    public async logout() {
        await this.service.request.post('/api/account/logout');
        location.href = '/access';
    }
}

export default LayoutAuthoringComponent;